import {useCallback, useContext} from 'react'

import useSushi from './useSushi'
import {useWallet} from 'use-wallet'

import {FarmContext} from "../contexts/farm_provider/farm_provider";

import BigNumber from "bignumber.js";

const useReward = () => {
    const {account} = useWallet();
    const sushi = useSushi();
    const {sC} = useContext(FarmContext);

    const handleReward = useCallback(async () => {
        const txHash = await sC.methods
            .getReward()
            .send({from: account})
            .on('transactionHash', (tx: any) => {
                console.log(tx);
                return tx.transactionHash
            });
        return txHash
    }, [account, sushi]);

    return {onReward: handleReward}
};

export default useReward
